export default function getPathogenList(relation) {

  // realtion = "男方父亲"

  const list = {
    "男方": new Map([
      ["p1,m0", "男方致病，女方无关"],
      ["p2,m0", "男方正常，女方无关"]
    ]),
    "女方": new Map([
      ["p0,m1", "男方无关，女方致病"],
      ["p0,m2", "男方无关，女方正常"]
    ]),
    "子代": new Map([
      ["p0,m0", "男方未知，女方未知"],
      ["p0,m1", "男方无关，女方致病"],
      ["p0,m2", "男方无关，女方正常"],
      ["p1,m1", "男方致病，女方致病"],
      ["p1,m2", "男方致病，女方正常"],
      ["p2,m2", "男方正常，女方正常"],
      ["p2,m1", "男方正常，女方致病"]
    ]),
    "儿子": new Map([
      ["p0,m0", "男方未知，女方未知"],
      ["p0,m1", "男方无关，女方致病"],
      ["p0,m2", "男方无关，女方正常"],
      ["p1,m1", "男方致病，女方致病"],
      ["p1,m2", "男方致病，女方正常"],
      ["p2,m2", "男方正常，女方正常"],
      ["p2,m1", "男方正常，女方致病"]
    ]),
    "女儿": new Map([
      ["p0,m0", "男方未知，女方未知"],
      ["p0,m1", "男方无关，女方致病"],
      ["p0,m2", "男方无关，女方正常"],
      ["p1,m1", "男方致病，女方致病"],
      ["p1,m2", "男方致病，女方正常"],
      ["p2,m2", "男方正常，女方正常"],
      ["p2,m1", "男方正常，女方致病"]
    ]),
    "流产组织": new Map([
      ["p0,m0", "男方未知，女方未知"],
      ["p0,m1", "男方无关，女方致病"],
      ["p0,m2", "男方无关，女方正常"],
      ["p1,m1", "男方致病，女方致病"],
      ["p1,m2", "男方致病，女方正常"],
      ["p2,m2", "男方正常，女方正常"],
      ["p2,m1", "男方正常，女方致病"]
    ]),
    "羊水": new Map([
      ["p0,m0", "男方未知，女方未知"],
      ["p0,m1", "男方无关，女方致病"],
      ["p0,m2", "男方无关，女方正常"],
      ["p1,m1", "男方致病，女方致病"],
      ["p1,m2", "男方致病，女方正常"],
      ["p2,m2", "男方正常，女方正常"],
      ["p2,m1", "男方正常，女方致病"]
    ]),
    "单精子": new Map([
      ["p2,m0", "男方正常，女方无关"],
      ["p1,m0", "男方致病，女方无关"],
      ["p0,m0", "男方未知，女方无关"],
    ]),
    "极体": new Map([
      ["p0,m2", "男方无关，女方正常"],
      ["p0,m1", "男方无关，女方致病"],
      ["p0,m0", "男方无关，女方未知"],
    ])
  }

  // const relationsWrap = ["男方", "女方", "子代"]
  //
  // const index = relationsWrap.findIndex(
  //   (relationWrap) => relation.includes(relationWrap)
  // )
  //
  // return list[relationsWrap[index]]

  if ((relation || "").includes("男方")) {
    return list["男方"]
  }
  if ((relation || "").includes("女方")) {
    return list["女方"]
  }
  if ((relation || "").includes("儿子")) {
    return list["儿子"]
  }
  if ((relation || "").includes("女儿")) {
    return list["女儿"]
  }
  if ((relation || "").includes("子代")) {
    return list["子代"]
  }
  if ((relation || "").includes("流产组织")) {
    return list["流产组织"]
  }
  if ((relation || "").includes("羊水")) {
    return list["羊水"]
  }
  if ((relation || "").includes("极体")) {
    return list["极体"]
  }
  if ((relation || "").includes("单精子")) {
    return list["单精子"]
  }

  return null
}



// WEBPACK FOOTER //
// ./src/app/utils/pathogenDispose.js